<p class="ds-heading-1">{{ 'PERFORMANCE.accountOverview.heading' | translate }}</p>
<div class="home-balance-box">
  <div class="balance-row total-info">
    <p class="ds-ui-2 ds-color-core-neutral-7">{{ 'PERFORMANCE.accountOverview.totalValue.name' | translate }}</p>
    <p class="ds-title-2">{{ totalAmount.toFixed(0) | thousand: currency }}</p>
  </div>

  <app-ds-info-row
    [title]="'PERFORMANCE.accountOverview.netInvestment.name' | translate"
    [value]="netInvestment.toFixed(0) | thousand: currency"
    [info]="'PERFORMANCE.accountOverview.netInvestment.info' | translate"
  ></app-ds-info-row>

  <app-ds-info-row
    [title]="'PERFORMANCE.accountOverview.totalReturn.name' | translate"
    [value]="netReturn.toFixed(0) | thousand: currency : netReturn > 0"
    [info]="'PERFORMANCE.accountOverview.totalReturn.info'  | translate"
    [customStyle]="'border-bottom: var(--border-1) solid var(--color-core-neutral-3);'"
  ></app-ds-info-row>
</div>
